$(function() {
	// webticker 
	$('#webTicker').webTicker();
});
